// Sidebar navigation. adminOnly items are hidden from resellers.
export const navItems = [
  { label: 'Dashboard', path: '/' },
  { label: 'Product Analysis', path: '/products' },
  { label: 'Reseller Analysis', path: '/resellers' },
  { label: 'Reports', path: '/reports' },
  { label: 'Alerts', path: '/alerts', adminOnly: true },
  { label: 'System Status', path: '/system-status', adminOnly: true },
  { label: 'Provisioning', path: '/provisioning', adminOnly: true },
  { label: 'Product Pricing', path: '/product-pricing', adminOnly: true },
  { label: 'User Management', path: '/users', adminOnly: true },
];
